<template>
  <!-- MODAL Edit Machine -->
  <div id="editMachineModal" class="col-12 justify-content-center" style="padding: 15vh 12%">
    <div class="col-12 m-0 p-0 section-container rounded-5 shadow">
      <!-- HEAD -->
      <div class="row overflow-hidden col-12 m-0 p-0 text-white rounded-top-5 pb-1 h-100 bg-lat1">
        <div class="col-6">
          <h6 class="lh-1 tx-left tx-white mb-2 ps-1 pt-2">
            <ion-icon name="cog" class="tx-18 me-2 align-bottom"></ion-icon>
            {{ dictionary['Editar máquina'][session.user.language] + ": " + editMachineData.label }}
          </h6>
        </div>

        <button type="button" @click="saveMachine" id="btnSaveMachine"
          class="col-5 col-md-3 button-ok bg-primary border-white m-1 ms-auto pb-1 btn"
          style="max-height: 34px;">
          <span class="button-text text-white">
            <ion-icon name="create-outline"
              class="text-white p-0 m-auto tx-24 hydrated"></ion-icon>
            <span class="text-white m-auto">
              {{ dictionary['Guardar cambios'][session.user.language] }}
            </span>
          </span>
        </button>

        <div class="col-auto m-0 p-0 d-flex justify-content-end btn" @click="$emit('toggleEditMachineModal')">
          <ion-icon name="close" class="ms-auto tx-30 pt-1 pe-1 tx-white align-bottom"></ion-icon>
        </div>
      </div>

      <!-- CONTENT Edit Machine -->
      <div class="m-0 p-0 pe-3 w-100 rounded-bottom-5 text-white" style="background-color: #03103e;">
        <div style="overflow: scroll; overflow-x: hidden; max-height: 60vh;">
          <div class="col-12 p-3 pe-0 pb-0">

            <!-- FORM Machine -->
            <form class="row m-0 p-0 pe-3 overflow-hidden">
              <div class="col-md-6 col-12 m-0 mb-3 p-0 ps-2 pe-2">
                <div class="form-group border rounded mb-3 col-md-12 col-12 m-0 p-1 d-flex flex-wrap">
                  <div class="row col-12 bg-lat1 text-white p-0 m-0 justify-content-around">
                    <div class="col-md-4 col-12 text-white p-1 m-0 rounded">
                      <label class="text-start ps-3 pt-1">
                        {{ dictionary['Máquina'][session.user.language] }}</label>
                    </div>
                  </div>
                  <div class="row col-12 m-0 p-2 rounded-bottom">
                    <!-- NOMBRE -->
                    <div class="col-md-6 col-12 p-1 m-0">
                      <label class="col-12 p-0 pt-1 tx-14">
                        {{ dictionary['Nombre'][session.user.language] }}
                      </label>
                      <input v-model="editMachineData.label" id="inputEditMachineName" type="text"
                        v-on:change="dataHasChanged=true"
                        class="form-control form-control-line bg-white" style="color:black; min-width: 100px !important;">
                    </div>
                    <!-- PADRE -->
                    <div class="col-lg-6 col-md-6 col-12 p-1 m-0">
                      <label class="col-12 p-0 pt-1 tx-14">
                        {{ dictionary['Emplazamiento'][session.user.language] }}
                      </label>
                      <select readonly disabled v-model="editMachineData.parent" id="selectNewMachineType"
                        v-on:change="dataHasChanged=true"
                        class="form-control form-control-line bg-white" style="color:black; height: 33.5px;">
                        <option v-for="emplacement in emplacementList" :key="emplacement.id" :value="emplacement.id">
                          {{ emplacement.label }}</option>
                      </select>
                    </div>

                    <!-- CONTENT Map -->
                    <div class="col-12 pt-3 p-0 m-0">
                      <div v-if="this.$route.params.currentDisplay === 'commandCenters'" id="machineMapContent"
                        class="m-0 p-3 rounded-3" style="height: 250px; border:solid 2px;">
                      </div>
                    </div>

                    <!-- LATITUD -->
                    <div class="col-lg-6 col-md-6 col-12 p-1 m-0">
                      <label class="col-12 p-0 tx-14">
                        {{ dictionary['Latitud'][session.user.language] }}
                      </label>
                      <div class="col-md-12 p-0">
                        <input v-model="editMachineData.geoJSON.geometry.coordinates[0]" id="inputEditBundleId"
                          v-on:change="dataHasChanged=true"
                          type="number" min=0 class="form-control form-control-line bg-white" style="color:black; min-width: 100px !important;"
                          @change="onPositionChanged">
                      </div>
                    </div>

                    <!-- LONGITUD -->
                    <div class="col-lg-6 col-md-6 col-12 p-1 m-0">
                      <label class="col-12 p-0 tx-14">
                        {{ dictionary['Longitud'][session.user.language] }}
                      </label>
                      <div class="col-md-12 p-0">
                        <input v-model="editMachineData.geoJSON.geometry.coordinates[1]" id="inputEditBundleId"
                          v-on:change="dataHasChanged=true"
                          type="number" min=0 class="form-control form-control-line bg-white" style="color:black; min-width: 100px !important;"
                          @change="onPositionChanged">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row justify-content-center m-0 p-0 bg-lat1 rounded-5">
                  <!-- FORM Machine Image -->
                  <form class="col-12 m-0 p-2 pt-0"
                    :class="!(this.editMachineData.variables.dynamic.urlPlano && this.editMachineData.variables.dynamic.urlPlano.value) ? 'col-lg-12' : 'col-lg-6'">
                    <div class="justify-content-center text-white text-center m-0 p-0">
                      <label class="col-12 p-2 ps-4 mt-0 tx-center tx-11">
                        {{ dictionary['Imágen de la máquina'][session.user.language].toUpperCase() }}
                      </label>
                      <hr class="text-white m-0 ms-3 me-3">
                      <label class="col-12 p-3 pt-0 pb-2 mt-1 tx-white tx-light tx-11">
                        {{ dictionary["Tamaño recomendado"][session.user.language] + ': 1000x1000px' }}
                      </label>

                      <img v-if="machineImageForm?.file === ''" id="machineImage" class="w-100 img-fluid" style="width: auto; padding: 0 1rem 1rem 1rem;"
                        :src="displayImage(this.editMachineData.imgSrc)">

                      <div v-if="machineImageForm?.file != ''" class="myMachineImagePreview w-100 ps-3 pe-3 pt-0 pb-2">
                        <div class="d-flex flex-column">
                          <button type="button" @click="onRemoveEditMachineImage()" title="Remove file"
                            style="line-height: 0; width: 25px; height: 25px"
                            class="p-1 m-0 bg-clomos-white rounded ms-auto">
                            <ion-icon name="close" class="tx-18 tx-black align-bottom"></ion-icon>
                          </button>
                          <img style="max-width: 200px; width: auto; padding: 1rem; margin: auto;"
                            :src="displayEditMachineImageThumbnail(machineImageForm?.file)" />
                        </div>
                      </div>

                      <div id="machineImageUploadFormContainer" class="d-flex row p-3 pb-0 pt-0">
                        <input type="file" id="machineImageUploadSrc"
                          class="col-12 mb-3 file-button btn btn-secondary rounded tx-12"
                          style="height: 2.3rem; min-width: 180px;" @change="onChangeEditMachineImage"
                          accept=".png, .jpg">

                        <button :disabled="machineImageForm?.file === ''" type="button"
                          @click="setEditMachineImage" id="machineImageUploadSubmit"
                          :style="(machineImageForm?.file === '') ?'opacity: 0.6; pointer-events: none;' :''"
                          class="col-8 ms-0 me-auto button-ok rounded-3 c-pointer" style="background-color: #03103e;">
                          <span class="button-text text-white">
                            <ion-icon name="image-outline" class="text-white pt-0 me-2 tx-14 hydrated"></ion-icon>
                            <span class="text-white mt-0 tx-12">{{ dictionary['Guardar archivo'][session.user.language]}}</span>
                          </span>
                        </button>

                        <button :disabled="editMachineData.imgSrc === ''" type="button"
                        class="col-3 ms-auto me-0 button-ok border-white rounded shadow entity-viewer-toolbar-btn c-pointer"
                        style="background-color: #03103e;"
                        :style="(editMachineData.imgSrc === '') ?'opacity: 0.6; pointer-events: none;' :''"
                        @click="onToggleDeleteDclImageModal">
                          <span class="button-text text-white">
                            <ion-icon name="trash-outline" class="pt-0 me-0 tx-18 hydrated" :title="dictionary['Eliminar'][session.user.language]"></ion-icon>
                          </span>
                        </button>
                      </div>

                    </div>
                  </form>

                  <!-- FORM Machine Blueprint -->
                  <form
                    v-if="this.editMachineData.variables.dynamic.urlPlano && this.editMachineData.variables.dynamic.urlPlano.value"
                    class="col-6 m-0 p-2 pt-0">
                    <div class="justify-content-center bg-menu text-white rounded text-center m-0 p-0">

                      <label class="col-12 p-2 ps-4 m-0 tx-center tx-11">
                        {{ dictionary["Plano"][session.user.language].toUpperCase() }}
                      </label>
                      <hr class="text-white m-0 ms-3 me-3">
                      <label class="col-12 p-3 pt-0 pb-2 tx-white tx-light tx-11  ">
                        {{ dictionary["Tamaño recomendado"][session.user.language] + ': 1000x1000px' }}
                      </label>
                      <img id="machineBlueprint" class="w-100 img-fluid" style="width: auto; padding: 0 1rem 1rem 1rem;"
                        :src="displayBlueprint()">

                      <div v-if="machineBlueprintForm.file != ''"
                        class="myMachineBlueprintPreview w-100 ps-3 pe-3 pt-0 pb-2">
                        <div class="w-100 ps-3 pe-3 pt-0 pb-2">
                          <button type="button" @click="onRemoveEditMachineBlueprint()" title="Remove file"
                            style="line-height: 0; width: 25px; height: 25px"
                            class="p-1 m-0 bg-clomos-white rounded ms-auto">
                            <ion-icon name="close" class="text-white pt-0 me-2 tx-14 hydrated md"></ion-icon>
                          </button>
                          <img style="max-width: 200px; width: auto; padding: 1rem; margin: auto;"
                            :src="displayEditMachineBlueprintThumbnail(machineBlueprintForm.file)" />
                        </div>
                      </div>

                      <div id="machineBlueprintUploadFormContainer" class="w-100 p-3 pt-0">
                        <input type="file" id="machineBlueprintUploadSrc"
                          class="col-12 mb-3 file-button btn btn-secondary rounded tx-12"
                          style="height: 2.3rem; min-width: 180px;" @change="onChangeEditMachineBlueprint"
                          accept=".png, .jpg">
                        <button type="button" id="machineBlueprintUploadSubmit" @click="setEditMachineBlueprint"
                          class="button-ok gradient-tablas rounded-3">
                          <span class="button-text text-white">
                            <ion-icon name="image-outline" class="text-white pt-0 me-2 tx-14 hydrated md"></ion-icon>
                            <span class="text-white mt-0 tx-12">{{ dictionary['Guardar archivo'][session.user.language]}}</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              
                <div v-if="isFabricante" class="row justify-content-center m-0 mt-3 p-0 bg-lat1 rounded-5">
                  <div class="row bg-lat1 text-white m-0 p-0 pb-3 rounded-5 border justify-content-between">
                    <label class="col-12 p-0 pt-2 pb-2 ps-3 text-white tx-bold tx-16 border-bottom">
                      {{ dictionary['Señales'][session.user.language] }}
                    </label>

                    <div class="col-12 d-flex flex-wrap m-0 p-0 border-bottom">

                      <div class="col-3 m-0 p-2 align-content-end">
                        <label class="col-12 p-0 text-white tx-16">
                          {{ dictionary['Nueva configuración'][session.user.language] }}:
                        </label>
                        <select v-model="newSignalConfig.targetSignal" id="selectNewTargetSignal"
                          class="col-5 form-control bg-white" style="color:black; height: 33.5px;">
                          <option v-for="signal in machineSignals" :key="signal.label" :value="signal.variableId">
                            {{ signal.label }}
                          </option>
                        </select>
                      </div>

                      <div class="col-3 m-0 p-2 align-content-end">
                        <label class="col-12 p-0 text-white tx-16">
                          {{ dictionary['Dispositivo'][session.user.language] }}:
                        </label>
                        <select v-model="newSignalConfig.targetDevice" id="selectNewTargetDevice"
                          class="col-3 bg-white form-control" style="color:black; height: 33.5px;">
                          <option v-for="child in childrenList" :key="child.label" :value="child.id">
                            {{ child.id }}
                          </option>
                        </select>
                      </div>

                      <div class="col-3 m-0 p-2 align-content-end">
                        <label class="col-12 p-0 text-white tx-16">
                          {{ dictionary['Estado'][session.user.language] }}:
                        </label>
                        <select v-model="newSignalConfig.targetStatus" id="selectNewTargetStatus"
                          class="col-3 bg-white form-control" style="color:black; height: 33.5px;">
                          <option key="0" value="0">
                            {{ 0 }}
                          </option>
                          <option key="1" value="1">
                            {{ 1 }}
                          </option>
                          <option key="2" value="2">
                            {{ 2 }}
                          </option>
                          <option key="3" value="3">
                            {{ 3 }}
                          </option>
                          <option key="4" value="4">
                            {{ 4 }}
                          </option>
                        </select>
                      </div>

                      <div class="col-2 m-auto p-0">
                        <div style="width: 2rem; height: 2rem; border-radius: 1rem; border: solid 1px white;" class="c-pointer tx-18 bg-primary m-auto p-0" @click="addSignalTarget()">
                          +
                        </div>
                      </div>
                    </div>
                    
                    <div class="row col-12 m-0 p-2 border-bottom" v-for="signal, i in machineSignals" :key="i">

                      <input v-model="signal.newLabel"
                        class="col-3 m-0 p-0 ps-2"
                        id="signalNewLabel"
                        type="text"
                        style="color:white; background: #ffffff00; border: none; border-bottom: solid 1px white; border-radius: 0; min-width: auto !important;">

                      <div class="col-3 d-flex flex-row m-0 ms-auto p-0 pe-2 align-content-end">
                        <label class="m-0 ms-auto me-2 p-0 pt-1 text-white tx-16" style="min-width: auto;">
                          {{ dictionary['Tipo'][session.user.language] }}:
                        </label>
                      
                        <select v-model="signal.distributionGroup" id="selectNewTargetStatus"
                          class="bg-white form-control me-0 ms-0 ps-1" style="color:black; height: 33.5px; width: 5rem !important;">
                          <option key="0" value="0">
                            {{ dictionary['Estado'][session.user.language] }}
                          </option>
                          <option key="1" value="1">
                            {{ dictionary['Alarma'][session.user.language] }}
                          </option>
                          <option key="2" value="2">
                            {{ dictionary['Piloto'][session.user.language] }}
                          </option>
                          <option key="3" value="3">
                            {{ dictionary['Aviso'][session.user.language] }}
                          </option>
                          <option key="4" value="4">
                            {{ dictionary['Invisible'][session.user.language] }}
                          </option>
                        </select>
                      </div>

                      <button type="button" @click="onSubmitSignalConfig(signal)" id="btnSubmitSignalConfig"
                        class="col-3 button-ok rounded-3" style="max-height: 34px; background-color: #03103e;">
                        <span class="text-white mt-0">
                          {{ dictionary['Configurar'][session.user.language] }}
                        </span>
                      </button>

                      <div class="row col-12 m-0 p-0" v-for="set, i in signalConfigs[signal.variableId]?.['Activos'] || []" :key="i">
                        <span class="col-2 m-auto mb-0 p-0 tx-bold text-white"> 
                          {{ dictionary['Dispositivo'][session.user.language] }}:
                        </span>
                        <span class="col-3 m-auto mb-0 p-0 text-white"> 
                          {{ signalConfigs[signal.variableId]?.['Activos'][i] }}
                        </span>
                        <span class="col-2 m-auto mb-0 p-0 tx-bold text-white"> 
                          {{ dictionary['Estado'][session.user.language] }}:
                        </span>
                        <span class="col-3 m-auto mb-0 p-0 text-white"> 
                          {{ signalConfigs[signal.variableId]?.['Estados'][i] }}
                        </span>
                        <div style="width: 2rem; height: 2rem; border-radius: 1rem; border: solid 1px white;" class="c-pointer tx-18 bg-primary m-0 ms-auto mt-2 p-0" @click="removeSignalTarget(signal.variableId,i)">
                          -
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
                
              <!-- Variables -->
              <div class="form-group col-md-6 col-12 p-2 pt-0 pb-3 text-center">
                <div class="row col-12 border p-1 m-0 rounded pb-3">
                  <div class="row col-12 text-white bg-lat1 p-0 m-0 justify-content-around rounded">
                    <div class="col-md-4 col-12 text-white p-1 m-0 rounded">
                      <label class="text-start ps-3 pt-1" style="min-width: 160px;">
                        {{ dictionary['Variables'][session.user.language] }}</label>
                    </div>
                  </div>

                  <div class="row col-12 mt-1 p-2 ps-4 pe-4 m-0 rounded-5 justify-content-around">
                    <p class="text-white p-1 m-1 mb-0 ms-0 me-0 tx-14 border border-start-0 border-top-0 border-end-0"> 
                      {{ dictionary['Tipo numéricas'][session.user.language] }}
                    </p>
                    <label class="col-12 p-0 pt-3 tx-14 tx-bold tx-clomos-dark" style="display:none;"
                      v-if="Object.keys(editMachineData.variables.analog)[0] != undefined">
                      {{ "ANA" }}
                    </label>

                    <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                    :style="(analogByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                      <div v-for="variable in analogByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.dynamicVariableId"
                        class="col-4">
                        <div class="m-0 p-0 w-100 pt-1">
                          <label class="col-12 p-0 text-white tx-14">
                            {{ variable.label }}
                          </label>
                          <input v-model="editMachineData.variables.analog[variable.label].value"
                            v-on:change="variablesHasChanged=true"
                            :id="(variable.isConfiguration === 'false') ? ('editMachine' + variable.label) : 'inputEditMachine' + variable.label"
                            type="text" :disabled="variable.isConfiguration === 'false'"
                            :data-id="editMachineData.variables.analog[variable.label].variableId"
                            :data-type="editMachineData.variables.analog[variable.label].type"
                            class="inputEditMachine form-control form-control-line bg-white" style="color:black;">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row col-12 mt-1 p-2 ps-4 pe-4 m-0 rounded-5 justify-content-around">
                    <p class="text-white p-1 m-1 mb-0 ms-0 me-0 tx-14 border border-start-0 border-top-0 border-end-0">
                      {{ dictionary['Tipo digitales'][session.user.language] }}
                    </p>
                    <label class="text-white tx-14 p-0 ps-2 pt-1" style="display:none;"
                      v-if="Object.keys(editMachineData.variables.digital)[0] != undefined">
                      {{ "DIG" }}
                    </label>

                    <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                    :style="(digitalByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                      <div v-for="variable in digitalByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.dynamicVariableId"
                        class="col-4">
                        <div class="m-0 p-0 w-100 pt-1">
                          <label class="col-12 p-0 text-white tx-14">
                            {{ variable.label }}
                          </label>
                          <div
                            :class="editMachineData.variables.digital[variable.label].value"
                            :id="editMachineData.variables.digital[variable.label].isConfiguration === 'false'
                              ? 'editMachine' + variable.label
                              : 'inputEditMachine' + variable.label"
                            :data-id="editMachineData.variables.digital[variable.label].variableId"
                            :data-type="editMachineData.variables.digital[variable.label].type"
                            :data-value="editMachineData.variables.digital[variable.label].value"
                            class="inputEditMachine form-control form-control-line border-0 m-0 p-2 bg-white text-black tx-10"
                            @click="handleClick(variable)"
                          >

                            {{
                              dictionary?.[variable.value]?.[session.user.language] ?? ''
                            }}
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row col-12 mt-1 p-2 ps-4 pe-4 m-0 rounded-5 justify-content-around">
                    <p class="text-white p-1 m-1 mb-0 ms-0 me-0 tx-14 border border-start-0 border-top-0 border-end-0">
                      {{ dictionary['Tipo texto'][session.user.language] }}
                    </p>
                    <label class="col-12 p-0 pt-3 tx-14 tx-bold tx-clomos-dark" style="display:none;"
                      v-if="Object.keys(editMachineData.variables.dynamic)[0] != undefined && Object.keys(editMachineData.variables.dynamic)[0] != 'configuracion'">
                      {{ "DIN" }}
                    </label>

                    <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                    :style="(dynamicByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                      <div v-for="variable in dynamicByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.dynamicVariableId"
                        class="col-12">
                        <div class="m-0 p-0 w-100 pt-1">
                          <label class="col-12 p-0 text-white tx-14">
                            {{ variable.label }}
                          </label>
                          <input v-model="editMachineData.variables.dynamic[variable.label].value"
                            v-on:change="variablesHasChanged=true"
                            :id="(variable.isConfiguration === 'false') ? ('editMachine' + variable.label) : 'inputEditMachine' + variable.label"
                            type="text" :disabled="variable.isConfiguration === 'false'"
                            :data-id="editMachineData.variables.dynamic[variable.label].variableId"
                            :data-type="editMachineData.variables.dynamic[variable.label].type"
                            class="inputEditMachine form-control form-control-line bg-white" style="color:black;">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import $ from 'jquery';
import Leaflet from 'leaflet';
// Clomos
import api from '@/services/api';
import placeholderImage from '@/assets/img/placeholder_image.jpg';

export default {
  name: "EditMachineModal",
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    timeZones: {
      type: Object,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    },
    machineId: {
      type: String,
      required: true,
    },
    isOperario: {
      type: Boolean,
      required: true
    },
    isMantenimiento: {
      type: Boolean,
      required: true
    },
    isFabricante: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      editMachineData: {
        id: "",
        nifCif: "",
        dataConsumed: "",
        label: "",
        dclId: "",
        dclTypeId: "",
        dclClass: "",
        type: "",
        distributionGroup: "",
        parent: "",
        isBase: "",
        isPublic: 0,
        token: "",
        imgSrc: "",
        emplacement: "",
        fechaUltimaComunicacion: "",
        tieneAlarmaActivada: "",
        version: "",
        geoJSON: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [0, 0]
          }
        },
        variables: {
          analog: {},
          digital: {},
          dynamic: {},
        }
      },
      machineConfigurationForm: {
        id: "",
        variableId: "",
        value: ""
      },
      emplacementList: [],
      childrenList: [],
      machineMap: undefined,
      machineMarker: undefined,
      machineImageForm: {
        id: this.machineId,
        variableId: "",
        nifCif: "",
        src: "",
        file: "",
        oldFileName: ""
      },
      machineBlueprintForm: {
        id: this.machineId,
        variableId: "",
        nifCif: "",
        src: "",
        file: "",
        oldFileName: ""
      },
      newSignalConfig: {
        targetSignal: undefined,          
        targetDevice: undefined,          
        targetStatus: undefined        
      },
      dataHasChanged: false,
      variablesHasChanged: false,
      signalConfigs: {}
    }
  },
  emits: ["toggleEditMachineModal"],
  computed: {
    machineSignals() {
      let machineSignals = [];
      let variablesArray = Object.values(this.editMachineData.variables.digital)
      for (let i in variablesArray) {
        if (variablesArray[i].isConfiguration === "false") {
          variablesArray[i].newLabel = ""+variablesArray[i].label
          machineSignals.push(variablesArray[i]);
        } 
      }
      return machineSignals;
    },
    analogByDistributionGroup() {
      const variablesArray = Object.values(this.editMachineData.variables.analog)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    },
    digitalByDistributionGroup() {
      const variablesArray = Object.values(this.editMachineData.variables.digital)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    },
    dynamicByDistributionGroup() {
      const variablesArray = Object.values(this.editMachineData.variables.dynamic)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    }
  },
  methods: {
    handleClick(variable) {
      if (variable.isConfiguration === 'false') {
        return;
      }
      this.variablesHasChanged=true
      const currentValue = this.editMachineData.variables.digital[variable.label].value;
      this.editMachineData.variables.digital[variable.label].value = currentValue === 'true' ? 'false' : 'true';
    },
    // SIGNALS
    addSignalTarget() {
      if (this.signalConfigs[this.newSignalConfig.targetSignal] === undefined) this.signalConfigs[this.newSignalConfig.targetSignal] = {"Activos": [], "Estados":[]};
      this.signalConfigs[this.newSignalConfig.targetSignal]["Activos"].push(this.newSignalConfig.targetDevice)
      this.signalConfigs[this.newSignalConfig.targetSignal]["Estados"].push(this.newSignalConfig.targetStatus)
    },
    removeSignalTarget(signal, i) {
      this.signalConfigs[signal]["Activos"].splice(i,1);
      this.signalConfigs[signal]["Estados"].splice(i,1);
      if (this.signalConfigs[signal]["Activos"].length === 0 && this.signalConfigs[signal]["Estados"].length === 0) delete this.signalConfigs[signal]; 
    },
    async onSubmitSignalConfig(signal) {
      let variablesData = { machineId: this.machineId };
      variablesData[signal.label] = {
        id: signal.variableId,
        newLabel: signal.newLabel,
        type: signal.type,
        distributionGroup: signal.distributionGroup
      }
      variablesData[signal.label]["Activos"] = this.signalConfigs[signal.variableId]["Activos"],
      variablesData[signal.label]["Estados"] = this.signalConfigs[signal.variableId]["Estados"]
      let response = await api.setMachineSignals(variablesData);
      if (response["status-code"] === "200" || response["status-code"] === "304") {
        for (let i in this.signalConfigs[signal.variableId]["Activos"]) {
          let deviceId = this.signalConfigs[signal.variableId]["Activos"][i]
          let targetDeviceResponse = await api.getDeviceData(deviceId);
          let targetDevice = api.parseDeviceFromResponse(targetDeviceResponse); 
          variablesData = { deviceId: deviceId };
          variablesData["est"] = {
            id: targetDevice.variables.analog["est"].variableId,
            type: targetDevice.variables.analog["est"].type,
            "Salida": signal.variableId,
            "Activos": [],
            "Estados": []
          }
          response = await api.setDeviceSignals(variablesData);
          if (response["status-code"] === "200" || response["status-code"] === "304") {
            window.alert("La señal ha sido modificado satisfactoriamente para el dispositivo " +targetDevice.label +"." );
          }
          else {
            window.alert("Error al modificar la señal.");
          }
        }
      }
      else {
        window.alert("Error al modificar la señal.");
      }
      await this.getEditMachineData();
    },
    //DISPLAY
    displayImage(src) {
      if (src != undefined && src != '') {
        try {
          return this.$clientConfig.api + '/ficheros/ficheros.php?fichero=' + src + '&identificadorusuario=' + this.session.user.id + '&Token=' + localStorage.getItem("ClomosAuthToken");
        }
        catch (e) {
          console.warn(e);
        }
      }
      return placeholderImage;
    },
    displayBlueprint() {
      let src = "";
      if (this.editMachineData.variables != undefined
        && this.editMachineData.variables.dynamic != undefined
        && this.editMachineData.variables.dynamic.urlPlano != undefined)
        src = this.editMachineData.variables.dynamic.urlPlano.value;
      if (src != undefined && src != '') {
        try {
          return this.$clientConfig.api + '/ficheros/ficheros.php?fichero=' + src + '&identificadorusuario=' + this.session.user.id + '&Token=' + localStorage.getItem("ClomosAuthToken");
        }
        catch (e) {
          console.warn(e);
        }
      }
      return placeholderImage;
    },
    displayEditMachineImageThumbnail(file) {
      if (file === '' || file === undefined) return "";
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
    onChangeEditMachineImage(event) {
      if (event.target.files[0] != undefined && event.target.files[0].size > 2097152) {
        this.onRemoveEditMachineImage();
        alert("El tamaño del fichero debe ser inferior a 2Mb.");
        return;
      }
      if ((event.target.files[0]?.name || "") != "") {
        this.onRemoveEditMachineImage();
        alert("El tamaño del fichero debe ser inferior a 2Mb.");
        return;
      }
      this.machineImageForm.nifCif = this.editMachineData.nifCif;
      this.machineImageForm.file = event.target.files[0];
      this.machineImageForm.src = event.target.files[0].name;
      this.machineImageForm.name = event.target.files[0].name;
      this.machineImageForm.oldFileName = ""+this.editMachineData.imgSrc;
    },
    onRemoveEditMachineImage() {
      $("#machineImageUploadSrc").get()[0].value = "";
      this.machineImageForm.nifCif = "";
      this.machineImageForm.file = "";
      this.machineImageForm.src = this.editMachineData.imgSrc;
      this.machineImageForm.name = this.editMachineData.imgSrc;
      this.machineImageForm.oldFileName = "";
    },
    displayEditMachineBlueprintThumbnail(file) {
      if (file === '' || file === undefined) return "";
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
    onChangeEditMachineBlueprint(event) {
      if (event.target.files[0] != undefined && event.target.files[0].size > 2097152) {
        this.onRemoveEditMachineBlueprint();
        alert("El tamaño del fichero debe ser inferior a 2Mb.");
        return;
      }
      if ((event.target.files[0]?.name || "") != "") {
        this.onRemoveEditMachineBlueprint();
        alert("El tamaño del fichero debe ser inferior a 2Mb.");
        return;
      }
      this.machineBlueprintForm.nifCif = this.editMachineData.nifCif;
      this.machineBlueprintForm.file = event.target.files[0];
      this.machineBlueprintForm.src = event.target.files[0].name;
      this.machineBlueprintForm.name = event.target.files[0].name;
      this.machineBlueprintForm.oldFileName = ""+this.editMachineData.variables?.dynamic?.urlPlano?.value
    },
    onRemoveEditMachineBlueprint() {
      $("#machineBlueprintUploadSrc").get()[0].value = "";
      this.machineBlueprintForm.nifCif = "";
      this.machineBlueprintForm.file = "";
      this.machineBlueprintForm.src = "";
      this.machineBlueprintForm.name = this.editMachineData.variables?.dynamic?.urlPlano?.value
      this.machineBlueprintForm.oldFileName = "";
    },
    onPositionChanged() {
      if (this.$route.params.currentDisplay === 'commandCenters') {
        this.machineMap.removeLayer(this.machineMarker);
        this.machineMarker = Leaflet.marker([this.editMachineData.geoJSON.geometry.coordinates[0], this.editMachineData.geoJSON.geometry.coordinates[1]]).addTo(this.machineMap);
        this.displayMachineMap()
      }
    },
    // SET
    displayMachineMap() {
      if (this.machineMap != undefined) {
        this.machineMap.invalidateSize();
        this.machineMap.remove();
      }
      var machineMap = Leaflet.map("machineMapContent");
      Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?lang=' + this.session.user.language, { maxZoom: 19 }).addTo(machineMap);
      machineMap.on('click', this.onSetNewCoordinates)

      this.machineMap = machineMap;

      let machineMapListForGroup = [];
      if ($(".leaflet-control-attribution").get()[0] != undefined) $(".leaflet-control-attribution").get()[0].remove();
      var machineMarker = Leaflet.marker([this.editMachineData.geoJSON.geometry.coordinates[0], this.editMachineData.geoJSON.geometry.coordinates[1]]);
      machineMarker.addTo(machineMap);
      machineMapListForGroup.push(machineMarker);
      var machineMapGroup = Leaflet.featureGroup(machineMapListForGroup);
      this.machineMap.fitBounds(machineMapGroup.getBounds());

      this.machineMarker = machineMarker;
    },
    onSetNewCoordinates(event) {
      this.editMachineData.geoJSON = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [Number(event.latlng.lat), Number(event.latlng.lng)]
        }
      }
      this.machineMap.removeLayer(this.machineMarker);
      this.machineMarker = Leaflet.marker([this.editMachineData.geoJSON.geometry.coordinates[0], this.editMachineData.geoJSON.geometry.coordinates[1]]).addTo(this.machineMap);
    },
    async saveMachine() {
      if (this.dataHasChanged === true) await this.setEditMachineData();
      if (this.variablesHasChanged === true) await this.setMachineVariables();
    },
    async setEditMachineData() {
      let response = await api.setMachineData(this.editMachineData);
      if (response["status-code"] === "200") {
        window.alert("La máquina ha sido modificada satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar la máquina.");
      }
      this.getEditMachineData();
    },
    async setMachineVariables() {
      let variablesData = {
        machineId: this.editMachineData.id
      };
      $(".inputEditMachine").get().forEach(input => {
        let variableLabel = input.id.replace("inputEditMachine", "");
        let ic = false;
        if (this.editMachineData.variables.analog[variableLabel] != undefined
          && this.editMachineData.variables.analog[variableLabel].isConfiguration === "true")
          ic = true;
        if (this.editMachineData.variables.digital[variableLabel] != undefined
          && this.editMachineData.variables.digital[variableLabel].isConfiguration === "true")
          ic = true;
        if (this.editMachineData.variables.dynamic[variableLabel] != undefined
          && this.editMachineData.variables.dynamic[variableLabel].isConfiguration === "true")
          ic = true;
        if (ic) {
          variablesData[variableLabel] = {
            value: (input.getAttribute("data-type") === "0")
              ? (input.getAttribute("data-value") === "true")
                ? 1
                : 0
              : input.value,
            id: input.getAttribute("data-id"),
            type: input.getAttribute("data-type")
          }
        }
      });
      let response = await api.setMachineVariables(variablesData);
      if (response["status-code"] === "200") {
        window.alert("Las variables han sido modificado satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar la máquina.");
      }
      this.getEditMachineData();
    },
    async setMachineConfiguration() {
      let response = await api.setMachineConfiguration(this.machineConfigurationForm);
      if (response["status-code"] === "200") {
        window.alert("La máquina ha sido modificado satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar la máquina.");
      }
      this.getEditMachineData();
    },
    async setEditMachineImage() {
      let response = await api.setMachineImage(this.machineImageForm);
      console.log(response);
      this.onRemoveEditMachineImage();
      this.getEditMachineData();
    },
    async setEditMachineBlueprint() {
      if (this.editMachineData.variables != undefined
        && this.editMachineData.variables.dynamic != undefined
        && this.editMachineData.variables.dynamic.urlPlano)
        this.machineBlueprintForm.variableId = this.editMachineData.variables.dynamic.urlPlano.variableId;
      let response = await api.setMachineBlueprint(this.machineBlueprintForm);
      console.log(response);
      this.onRemoveEditMachineImage();
      this.getEditMachineData();
    },
    async onToggleDeleteDclImageModal() {
      if (window.confirm(this.dictionary['¿Seguro que desea eliminar el fichero?'][this.session.user.language])) {
        this.onRemoveEditMachineImage();
        await this.setEditMachineImage();
        this.getEditMachineData();
      } else {
        // Cancel
      }
    },
    // GET 
    async getEditMachineData(callback) {
      let response = await api.getMachineData(this.machineId);
      this.editMachineData = api.parseMachineFromResponse(response);
      if (this.editMachineData.variables.dynamic['configuracion'] != undefined)
        this.machineConfigurationForm = {
          id: this.editMachineData.id,
          variableId: this.editMachineData.variables.dynamic['configuracion'].variableId,
          value: this.editMachineData.variables.dynamic['configuracion'].value
        }
      else this.machineConfigurationForm = {
        id: this.editMachineData.id,
        variableId: "",
        value: ""
      }
      await this.getDeviceList();
      for (let signal in this.machineSignals) {
        let events = this.machineSignals[signal].events;
        let onConfig = events["OnConfig"];
        if (onConfig == undefined || onConfig == "") continue
        let signalActivos = onConfig[0]["Activos"];
        let signalEstados = onConfig[0]["Estados"];
        let targetSignal = this.machineSignals[signal].variableId; 
        this.signalConfigs[targetSignal] = {"Activos": [], "Estados": []};
        for (let i in signalActivos) {
          let activo = signalActivos[i]; 
          let estado = signalEstados[i]; 
          this.signalConfigs[targetSignal]["Activos"].push(activo)
          this.signalConfigs[targetSignal]["Estados"].push(estado)
        }
      }
      let targetSignal; 
      for (let signal in this.machineSignals) {
        targetSignal = this.machineSignals[signal].variableId;
        break;
      }
      let targetDevice = this.childrenList[0]?.id || undefined;
      this.newSignalConfig = {
        targetSignal: targetSignal,          
        targetDevice: targetDevice,          
        targetStatus: "0"        
      }
      this.dataHasChanged = false;
      this.variablesHasChanged = false;
      this.machineImageForm.id = this.editMachineData.id;
      this.machineImageForm.variableId = this.editMachineData.imgSrc;
      this.machineImageForm.name = this.editMachineData.imgSrc;
      this.machineImageForm.oldFileName = "";
      if (callback && typeof callback === "function") callback(this.machineData);
    },
    async getEmplacementList() {
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getEmplacementList(request);
      for (let i in response.plantas) [
        this.emplacementList[i] = {
          id: response.plantas[i].idDcl,
          label: response.plantas[i].etiqueta,
        }
      ]
    },
    async getDeviceList() {
      this.childrenList = [];
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,
        where: "",
      };
      let response = await api.getDeviceListByCompany(request);
      let devices = api.parseDevicesFromResponse(response);
      for (let i in devices) {
        if (devices[i].parent === this.machineId) {
          this.childrenList.push(devices[i])
        }
      }
    }
  },
  async created() {
    await this.getEditMachineData();
    await this.getEmplacementList();
    if (this.$route.params.currentDisplay === 'commandCenters')
    setTimeout(() => { 
      this.displayMachineMap() 
      if (!this.isMantenimiento) {
        window.alert("No tiene permiso para visualizar esta pagina. Contacte con el administrador del sistema");
        this.$router.go(-1)
      }
    }, 300);

  }
}
</script>

<style>
#editMachineModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}

@media (max-width: 767px) {
  #machineImageUploadFormContainer {
    flex-direction: column;
  }

  #machineBlueprintUploadFormContainer {
    flex-direction: column;
  }
}
</style>